/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const loginJwtRequestSchema = z.object({
  username: z.coerce.string(),
  password: z.coerce.string(),
});
